import { DetalhesEmpresaInvestida } from "../../../model/detalhes-empresa-investida";
import { DetalhesInvestimento } from "../../../model/detalhes-investimento";
import { SetorTag } from "../../setor-primecap/model/setor-startup-tag";

export declare type CardClass =
  | 'dashboads-card'
  | 'rodadas-card'
  | 'detalhes-card'
  | 'contato-card'
  | null;

export class CardRodada {
  banner: string;
  logo: string;
  setorNome: string;
  setorCorTag: string;
  empresaNome: string;
  textoCard: string;
  valorRodada: number;
  valorCaptado: number;
  valorMinimo: number;
  participacao: number;
  qtdInvestidores: number;
  empresaUuid: string;
  tipoRodada: string;
  rodadaUuid: string;
}

export class DashboardCard {
  empresaUuid: string;
  empresaNome: string;
  empresaLogo: string;
  setorNome: string;
  setorCorTag: string;
}

export class DetalhesCard {
  empresaInvestida: DetalhesEmpresaInvestida;
  listaInvestimento: DetalhesInvestimento[];
  setorTag: SetorTag;
  ultimaLamina?: string;
  valuation?: number;
}

export class CardContato {
  uuid: string;
  nome: string;
  facebook?: string;
  instagram?: string;
  linkedin?: string;
  site?: string;
  email: string;
  telefone: string;
  observacao: string;
}
